import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/wkz_logo.svg'
import _imports_1 from '@/assets/images/seals/din-approved.jpg'
import _imports_2 from '@/assets/images/seals/ekomi-approved.png'
import _imports_3 from '@/assets/images/phone-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-02e05724"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"navigation-bar container\" data-v-02e05724><div class=\"logo\" data-v-02e05724><a href=\"/\" data-v-02e05724><img src=\"" + _imports_0 + "\" width=\"275\" data-v-02e05724></a></div><div class=\"seals d-none d-md-flex\" data-v-02e05724><div data-v-02e05724><img src=\"" + _imports_1 + "\" data-v-02e05724></div><div data-v-02e05724><img src=\"" + _imports_2 + "\" data-v-02e05724></div></div><div class=\"contact d-none d-lg-flex\" data-v-02e05724><a class=\"nav-link\" aria-current=\"page\" href=\"tel:021529939909\" data-v-02e05724><img src=\"" + _imports_3 + "\" width=\"25\" data-v-02e05724> 02152 - 993 9909 </a></div></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const IsScrolledToTop = ref<boolean>(true);
const IsOnHomePage = ref<boolean>(true);

onMounted(() => {
  console.log(useRoute().fullPath);

  useRouter().afterEach((to) => {
    IsOnHomePage.value = to.name == 'Home';
  });
  window.addEventListener('scroll', () => {
    IsScrolledToTop.value = window.scrollY == 0;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ small: !IsScrolledToTop.value || !IsOnHomePage.value })
  }, _hoisted_2, 2))
}
}

})